/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";
import { RequestQueryString } from "./constants";

export const getQueryText = (): string => {
  const queryText = sessionStorage.getItem(RequestQueryString);
  return queryText ? queryText : "";
};

// eslint-disable-next-line
export const useWindowWidth = () => {
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);
  return { width };
};

interface URLParams {
  candidateId: string;
  referenceId: string;
}

export interface IPlannedDownTimeInfo {
  status: string;
  serviceName: string;
  message: string;
}

export interface IReferenceMetaData {
  status: string;
  statusDate: string;
  candidatePreferredFirstName: string;
  candidateLastName: string;
  referenceFirstName: string;
  referenceLastName: string;
}

export interface IReferenceMetaError {
  status: number;
  statusCode?: number;
}

export const getURLParams = (): URLParams => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlData: URLParams = {
    candidateId: `${atob(urlParams.get("id") || "")}`,
    referenceId: `${urlParams.get("referenceid") || ""}`,
  };
  return urlData;
};

export function base64ToArrayBuffer(base64: string): Uint8Array {
  if (base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
  }
  return new Uint8Array(0);
}

export function getAppUpdatedDate(date?: Date): string {
  if (!date) date = new Date();
  const options = { year: "numeric", month: "long", day: "2-digit" } as const;
  return date.toLocaleString("en-US", options);
}
